import { InputField } from "../AddPatientGroup.style";
import * as React from "react";
import { useTranslation } from "hhn-commons";
import { errorsType } from "../PatientGroupUtils";

type InputFirstNameProps = {
  patientInfoData: any;
  onFormDataChange: (key: string, value: string) => void;
  onSetErrors: (key: string, value: boolean) => void;
  errors: errorsType;
};
export const InputFirstName = ({
  patientInfoData,
  onFormDataChange,
  onSetErrors,
  errors,
}: InputFirstNameProps) => {
  const { t } = useTranslation();
  const tNs = (key: string) => t(key, { ns: "patientGroup" });

  return (
    <InputField
      required
      id="first-name"
      label={tNs("firstNameLabel")}
      type="text"
      variant="standard"
      onBlur={e => {
        const firstName: string = e.target.value;
        onSetErrors("firstName", firstName.trim().length <= 0);
      }}
      error={errors.firstName}
      value={patientInfoData.firstName}
      onChange={e => {
        const firstName: string = e.target.value;
        onFormDataChange("firstName", firstName);
        onSetErrors("firstName", firstName.trim().length <= 0);
      }}
      helperText={errors.firstName ? tNs("invalidFirstName") : " "}
      slotProps={{
        inputLabel: { shrink: !!patientInfoData.firstName },
        htmlInput: {
          "data-testid": "first-name",
          maxLength: 25,
        },
      }}
    />
  );
};
